if (!customElements.get('gallery-slider-component')) {
  class GallerySlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.gallery-slider__items',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 2;
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.mobileItems,
        spaceBetween: columnGap.mobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: parseInt(this.tabletLargeItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(
              this.sliderInstance.slider.slides.indexOf(slide)
            );
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);
          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }
  }
  customElements.define('gallery-slider-component', GallerySlider);
}

/* ========================================
   Gallery Lightbox
   ======================================== */
if (!customElements.get('gallery-lightbox')) {
  class GalleryLightbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.overlay = this.querySelector('.gallery-lightbox__overlay');
      this.imgEl = this.querySelector('.gallery-lightbox__img');
      this.closeBtn = this.querySelector('.gallery-lightbox__close');

      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById('Gallery-' + this.sectionId);

      if (!this.section) return;

      this.bindTriggers();
      this.bindClose();
    }

    bindTriggers() {
      const triggers = this.section.querySelectorAll('[data-lightbox-src]');
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const src = trigger.dataset.lightboxSrc;
          const alt = trigger.dataset.lightboxAlt || '';
          this.open(src, alt);
        });
      });
    }

    bindClose() {
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('active')) this.close();
      });
    }

    open(src, alt) {
      this.imgEl.src = src;
      this.imgEl.alt = alt;
      this.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  customElements.define('gallery-lightbox', GalleryLightbox);
}